export default __webpack_public_path__ + "static/media/clio-colour-2.9e609740.jpg";